import { NgModule } from '@angular/core';
import { CommonModule as NgCommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { A11yModule } from '@angular/cdk/a11y';

import { PhxDropdownModule } from '../dropdown/phx-dropdown.module';
import { PhxMenuModule } from '../menu/menu.module';
import { PhxListModule } from '../list/list.module';
import { PhxCheckboxModule } from '../checkbox/checkbox.module';
import { PhxBadgeModule } from '../badge/phx-badge.module';
import { PhxTooltipModule } from '../tooltip/phx-tooltip.module';
import { PhxDividerModule } from '../divider/phx-divider.module';
import { PhxInputModule } from './../input/phx-input.module';
import { PhxIconModule } from '../icon/icon.module';
import { PhxRadioListModule } from '../radio-list/phx-radio-list.module';
import { PhxTagModule } from '../tag/phx-tag.module';
import { PhxSpinnerModule } from '../spinner/phx-spinner.module';
import { PhxIconButtonModule } from '../icon-button/phx-icon-button.module';
import { PhxTranslationsRootModule } from '../../translation/transloco-root.module';

import { PhxSelectComponent } from './select.component';
import { PhxOptionComponent } from './option.component';
import { PhxOptionItemComponent } from './option-item.component';
import { SelectFocusableItemDirective } from './selectFocusableItem.directive';
import { SelectFocusTrapItemDirective } from './selectFocusTrapItem.directive';
import { PhxSelectionListComponent } from './selection-list.component';
import { PhxCustomVirtualScrollDirective } from './phx-custom-virtual-scroll/phx-custom-virtual-scroll.directive';

@NgModule({
  imports: [
    NgCommonModule,
    ScrollingModule,
    A11yModule,
    PhxDropdownModule,
    PhxMenuModule,
    PhxListModule,
    FormsModule,
    PhxCheckboxModule,
    PhxBadgeModule,
    PhxTooltipModule,
    PhxDividerModule,
    PhxIconModule,
    PhxInputModule,
    PhxTranslationsRootModule,
    PhxTagModule,
    PhxRadioListModule,
    PhxIconButtonModule,
    PhxSpinnerModule,
  ],
  declarations: [
    PhxSelectComponent,
    PhxOptionComponent,
    PhxSelectionListComponent,
    PhxOptionItemComponent,
    SelectFocusableItemDirective,
    SelectFocusTrapItemDirective,
    PhxCustomVirtualScrollDirective,
  ],
  entryComponents: [PhxOptionComponent],
  exports: [PhxSelectComponent, PhxOptionComponent, SelectFocusableItemDirective, PhxSelectionListComponent],
})
export class PhxSelectModule {}